<template>
  <div>
    <div>
      <div class="top">
        <el-input
            v-model="search.qymc"
            placeholder="企业名称"
            style="width: 250px; margin-right: 10px"
            size="small"
            clearable
            @clear="clear('qymc')"
        />

        <el-button
          icon="el-icon-search" 
          size="small"
          @click="queryData()"
          >查询</el-button>

        <el-button
          type="danger"
          icon="el-icon-refresh-left"
          size="small"
          @click="reseData()"
          >重置</el-button>

      </div> 

      <el-table
        ref="multipleTable"
        :data="tableData"
        :highlight-current-row="true"
        stripe
        row-key="id"
        style="width: 100%; margin-top: 20px;border-radius:16px;"
        :loading="loading"
      >
        <el-table-column type="index" label="序号" width="55" />
        <el-table-column prop="qymc" width="150" label="企业名称" />
        <el-table-column prop="dm" label="企业统一社会信用代码" />
        <el-table-column prop="lx" label="行业类别"  />
        <el-table-column prop="zczb" label="注册资本" />
        <el-table-column prop="fddbr" label="法定代表人" />
        <el-table-column prop="username" label="联系人" />
        <el-table-column prop="phone" label="联系电话" />
        <el-table-column  label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDowns(scope.row,'详情')">下载信用报告</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, sizes,prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page.sync="page.current"
          :page-size.sync="page.size"
          :total="page.total"
          @current-change="queryData"
          @size-change="handleQuery"
        />
      </div>

    </div>

  </div>
</template>

<script>
import {getEnterpriseClient , getDetailsExport} from "@/views/financInstitutionPC/viewApi";
import { downloadFile } from "@/utils/index";

export default {
  components: {
  },
  data() {
    return {
      search:{
        qymc:'',
      },
      options:[],
      loading: false,
      page: {
        size: 10,
        total: 0,
        current: 1
      },
      tableData:[],
    }
  },
  mounted() {
    this.queryData();
  },
  methods: {

    handleQuery () {
      this.page.current = 1
      this.queryData()
    },
    queryData(){
      let param ={
        qymc: this.search.qymc,
        ...this.page,
      }
      getEnterpriseClient(param).then(res => {
        if (res.code == 1000) {
          this.tableData = res.data.records.map((item)=>{
              return {
                ...item
              }
          })
          this.page.total = res.data.total
        }
      })
    },

    changeItem( data ){
      this.search.cpmc = data.cpmc;
    },

    changeStatus( data ){
      this.search.status = data.value;
    },

    clear(key){
      key&&(this.search[key] = '')
      this.queryData();
    },


    //信用报告下载
    handleDowns(row , title){
      const loading = this.$loading({
        lock: true,
        text: "拼命导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      downloadFile(
        `/credit/enterprise/2001050004/exportDetail?creditCode=${row.dm}`,
        "get",
        (row.qymc+'_信用报告'),
        loading,
        "导出失败",
        ".doc",
        {
          creditCode: row.dm
        }
      );
    },

    reseData(){
      this.search={
        qymc:'',
      };
    },
    
  }
};
</script>
